import * as Yup from "yup";
import { TFunction } from "i18next";

export const objectShape = (t: TFunction) => ({
  description: Yup.string()
    .required(t("payfac.pageRatePlanModalRequiredField"))
    .min(1, t("payfac.pageRatePlanModalRequiredField")),
});
